import { Card, CardProps } from "@chakra-ui/react";

export default function TransparentCard({ children, ...props }: CardProps) {
  return (
    <Card 
      bg="transparent"
      border="1px solid"
      borderColor="gray.200"
      shadow="none"
      {...props}
    >
      {children}
    </Card>
  );
}